var map = {
	"./struct1.webp": 59840,
	"./struct10.webp": 45080,
	"./struct11.webp": 99803,
	"./struct12.webp": 77434,
	"./struct2.webp": 54509,
	"./struct3.webp": 29570,
	"./struct4.webp": 25471,
	"./struct5.webp": 81180,
	"./struct6.webp": 98041,
	"./struct7.webp": 13534,
	"./struct8.webp": 91723,
	"./struct9.webp": 94344
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1573;